<div class="grid justify-content-center">
    <div class="col-12 sm:col-8 md:col-6 lg:col-4 xl:col-3">
        <p-card class="loginCard">
            <div class="title">
                <div class="logo-container">
                    <img id="app-logo" class="logo-svg" src="../../assets/layout/images/Oncore_logo_black.svg" alt="Oncore logo"/>
                    <i class="fas fa-lock"></i>
                </div>
                
            </div>
            <span class="login-error" *ngIf="showErrorMessage && !loginForm.dirty">Felaktiga uppgifter</span>
            <form [formGroup]="loginForm" (ngSubmit)="loginSubmit(loginForm)">
                <div class="field">
                    <input type="text" pInputText formControlName="email" email placeholder="E-post">
                </div>
                <div class="field">
                    <input type="password" pInputText formControlName="password" placeholder="Lösenord">
                </div>
                <p-button type="submit" label="Submit"></p-button>
            </form>
        </p-card>
    </div>
</div>

